module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAQCAYAAAAFzx/vAAAA8ElEQVRIS73TbQuCMBQF4Dsk6YUKhKhQEP//jzJJqQiEilIMWZzEMNuW5ux8EXX6wOUe5m+2PI5P9I9Y1pxYkqQ8DHd0vlx7NWfTCTnOugA55xQEEd2StBd0PBqS69rEGCtAKHmek+9HlN0zrag5MMnzbDIM4/nfF4gbYECB6wgQYEDLvIF4iLFivBhzl2B8GCPGWc0HiJdYICxSl2BBsCj1CEEcQlX2h+NP5mq5IFRAFCmIwwDbdhQQQFmUID5q09Gya6qxfAWbdrTatU5gk47Wu9YZVHVU1DUtoKijsq5pA+sdlXVNK1h2FFdZ11TgA5HxsB3K8eP/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/arrow_down.png
// module id = BGxb
// module chunks = 2